import { Separator } from '../../../../../primitives/separator';

import { Spacing } from '../controls/spacing';
import { Appearance } from './appearance';

import { DividerEditorContentProps } from './types';

export type { DividerEditorStyleUpdates } from './types';

export function DividerEditorContent({
  backgroundColor,
  color,
  height,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  onHeightChange,
  onStyleChange,
}: DividerEditorContentProps) {
  return (
    <div className="grid gap-4">
      <Appearance
        backgroundColor={backgroundColor}
        color={color}
        height={height}
        onBackgroundColorChange={(backgroundColor) => onStyleChange({ backgroundColor })}
        onHeightChange={onHeightChange}
        onLineColorChange={(lineColor) => onStyleChange({ lineColor })}
      />

      <Separator />

      <Spacing
        margin={margin}
        onChangeMargin={(margin) => onStyleChange({ margin })}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        isPaddingVisible
        onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
        onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
        onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
        onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
      />
    </div>
  );
}
